import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CiviliteService {
    
    private apiURL = environment.appApiUrl + "civilite";

    constructor(private http: HttpClient) { }

    getCivilite(): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(this.apiURL + "/getAll");
    }
}
